import { assign } from "lodash";
import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { BaseQuestionComponent } from '../base-question/base-question.component';
import { ZodSharedValidator } from '@medsurf/flat-validators';
import { FormControl, FormGroup } from "@angular/forms";

@Component({
    selector: 'medsurf-quiz-indication-question',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './indication-question.component.html',
    styleUrls: ['./indication-question.component.scss'],
    standalone: false
})
export class IndicationQuestionComponent extends BaseQuestionComponent<FlatModels.QuestionEntityModels.IndicationQuestion> {
  override form = new FormGroup(
    {
      content: new FormControl(''),
      explanation: new FormControl(''),
      solution: new FormControl(0)
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.QuestionEntityModels.IndicationQuestionSchema.pick({
          content: true,
          explanation: true,
          solution: true,
        })
      ),
      updateOn: 'change'
    }
  );

  override updateForm() {
    if (this.index !== undefined && this.question) {
      let update = false;
      if (this.question.content !== this.form.value.content
        || this.question.explanation !== this.form.value.explanation
        || this.question.solution !== this.form.value.solution) {
        update = true;
      }
      if (update) {
        // Update Data
        this.form.reset(this.question);
        this.isSubmitted.set(false);
      }
    }
  }

  override onSubmit() {
    if (this.isSubmitted() || this.form.invalid || !this.question) {
      return;
    }
    this.isSubmitted.set(true);
    
    // Update Question
    const question = assign(this.question, this.form.value);

    // Request Update Question
    this.slideAuthorFacade.requestUpdateQuestion(question, 'history.question_update').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.form);
        this.isSubmitted.set(false);
      },
      next: () => {
        this.isSubmitted.set(false);
      }
    });
  }
}
